import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';

type Props = {
  children: JSX.Element;
};

const AuthGuard = (props: Props) => {
  const location = useLocation();
  const user = useSelector((state: RootState) => cacheSelectors.user(state));

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return props.children;
};

export default AuthGuard;
